import { useLayoutEffect } from "react";

// Jump to the top before first paint, bypassing the global smooth-scroll.
export default function useScrollTop() {
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);
}
